module.exports = __webpack_public_path__ + "static/media/check.58a151b4.svg";